import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_COUNT,
  SET_ROWS_PER_PAGE,
  SET_ROWS_ORIENTATION,
  SET_ORDER,
  SET_ORDERBY,
  SET_SWITCHES_FILTERS,
  GET_FILTER_REQUEST,
  GET_FILTER_SUCCESS,
  GET_ALL_REQUEST,
  GET_ALL_SUCCESS,
  GET_BY_ID_REQUEST,
  GET_BY_ID_SUCCESS,
  GET_LIST_PRODUCT_REQUEST,
  GET_LIST_PRODUCT_SUCCESS,
  SEARCH,
  GET_ALL_PROMOTION_KIT_REQUEST,
  SET_LOADING_COUNT,
  CLEAR_LIST_PRODUCT
} from './product-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingCount = (loading: Boolean) => {
  return {
    type: SET_LOADING_COUNT,
    loading
  };
};

export const getListProductsRequest = (payload: {
  queryString?: string;
  subsidiaryExternalCode?: string;
  brand?: string;
  onlyWithStock?: boolean;
}) => {
  return {
    type: GET_LIST_PRODUCT_REQUEST,
    payload
  };
};

export const getListProductsSuccess = payload => {
  return {
    type: GET_LIST_PRODUCT_SUCCESS,
    payload
  };
};

export const getFilterRequest = (queryString = '') => {
  return {
    type: GET_FILTER_REQUEST,
    queryString
  };
};

export const getFilterSuccess = (products: any, rowsCount?: any) => {
  return {
    type: GET_FILTER_SUCCESS,
    products,
    rowsCount
  };
};

export const getAllRequest = () => {
  return {
    type: GET_ALL_REQUEST
  };
};

export const getAllSuccess = (products: any) => {
  return {
    type: GET_ALL_SUCCESS,
    products
  };
};

export const getByIdRequest = (id: string) => {
  return {
    type: GET_BY_ID_REQUEST,
    id
  };
};

export const getByIdSuccess = (payload: any) => {
  return {
    type: GET_BY_ID_SUCCESS,
    payload
  };
};

export const setPage = (page: Number) => {
  return {
    type: SET_PAGE,
    page
  };
};

export const setRowsPerPage = (rowsPerPage: Number) => {
  return {
    type: SET_ROWS_PER_PAGE,
    rowsPerPage
  };
};

export const setRowsCount = (rowsCount: Number) => {
  return {
    type: SET_ROWS_COUNT,
    rowsCount
  };
};

export const setRowsOrientation = (rowsOrientation: string) => {
  return {
    type: SET_ROWS_ORIENTATION,
    rowsOrientation
  };
};

export const setOrder = (order: String) => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (orderBy: (string | boolean)[]) => {
  return {
    type: SET_ORDERBY,
    orderBy
  };
};

export const setSwitchesFilters = (payload: { name: string; value: boolean }) => {
  return {
    type: SET_SWITCHES_FILTERS,
    payload
  };
};

export const search = (queryString: string) => {
  return {
    type: SEARCH,
    queryString
  };
};

export const getAllPromotionKitRequest = (queryString?: string) => {
  return {
    type: GET_ALL_PROMOTION_KIT_REQUEST,
    queryString
  };
};

export const clearListProduct = () => {
  return { type: CLEAR_LIST_PRODUCT };
};
